<template>
  <form class="PasswordForm" action="" v-on:submit="onSubmit">
    <label for="password" style="display:none;">{{ $t("login.label") }}</label>
    <div>
      <input type="password" name="password" v-model="password" id="password" :placeholder="$t('login.label')">
      <p v-show="error" class="PasswordForm-error">{{ $t('login.errorMessage') }}</p>
    </div>
    <button type="button" @click="onSubmit">{{ $t('login.submit') }}</button>
  </form>
</template>

<script>
import { ref } from '@vue/reactivity'
// https://auth0.com/blog/getting-started-with-vue-3-composition-api/
export default {
  props: {
    callback: Function 
  },
  setup(props) {
    let password = ref('')
    let error = ref(false)

    function onSubmit(e) {
      e.preventDefault()
      // Kenzo_HommeEDTI
      if (password.value === 'Kenzo_HommeEDTI') {
        props.callback()
      } else {
        error.value = true
      }
    }
    
    return {
      password,
      error,
      onSubmit
    }
  }
}
</script>

<style lang="stylus">
.PasswordForm
  color white
  height 90px
  display flex

  align-items flex-start
  align-content center
  margin-top 30px
  justify-content center

  &-error
    color white
    text-align center
    margin-top 10px
    max-width 190px

  input
    background transparent
    border 1px solid white
    padding 6px 15px
    color white
    background rgba(255, 255, 255, 0.1)
    text-align center

    &::placeholder
      color rgba(255, 255, 255, 0.7)

  button
    text-transform uppercase
    margin-left 0px
    border none
    display inline-block
    cursor pointer
    background transparent
    color white
    font-family FuturaStd-bold, Arial, sans-serif
    border 1px solid transparent
    padding 7px 10px 5px 10px
    transition all 200ms ease-out
    &:hover
      color rgba(80, 80, 80, 1)
      background rgba(255, 255, 255, 0.9)

</style>